import { Select } from '@purpur/library';
import styled from 'styled-components';

export const SortSelector = styled(Select)`
    min-width: 12rem;
`;
